import { mutatorAction } from "satcheljs";
import { getConditionalFormattingStore } from "../store/store";
import type { ConditionalFormattingRule } from "../store/schema/ConditionalFormattingRule";
import type { MailboxInfo } from "owa-client-types";
import type { ConditionalFormattingScenario } from "../store/schema/ConditionalFormattingScenarioType";

const setConditionalFormattingRulesMutator: (mailboxInfo: MailboxInfo, updatedRules: ConditionalFormattingRule[], scenario: ConditionalFormattingScenario) => void = mutatorAction("setConditionalFormattingRules", function setConditionalFormattingRules(mailboxInfo: MailboxInfo, updatedRules: ConditionalFormattingRule[], scenario: ConditionalFormattingScenario): void {
    getConditionalFormattingStore(mailboxInfo, scenario).conditionalFormattingRules =
        updatedRules;
});
export default setConditionalFormattingRulesMutator;
